/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import { useRegistry } from 'live/services/registry'
import { useKeys } from 'live/hooks/useKeys'
import styled from 'styled-components'
import { useClickOutside } from '../../hooks/useClickOutside'
import useExportAnnotationReducer from './reducer'
import ExportAnnotationButton from './ExportAnnotationButton'
import SelectedItem from './SelectedItem'
import ExtensionService from 'live/services/extension'
import theme from 'live/services/theme'

const ExportAnnotation: React.FunctionComponent<ExportAnnotation> = props => {
    const { registry, event, ...rest } = props
    const keys = useKeys()
    const items = useRegistry(registry)
    const [{ open, selectedItem }, actions] = useExportAnnotationReducer()
    const ref = useRef(null)
    useClickOutside(ref, actions.closeDropdown)

    if (!items.length) return null

    return (
        <div className={`dropdown btn-group ${open ? 'open' : ''}`} ref={ref}>
            <ExportAnnotationButton
                onClick={items.length > 1 ? actions.openDropdown : () => actions.selectExportOption(items[0])}
                open={open}
                items={items}
            />
            {open && !selectedItem ? (
                <List
                    aria-labelledby="plugin-annotations_export-extension-point"
                    className="dropdown-menu dropdown-menu-right"
                    role="menu"
                >
                    {items.map(item => {
                        const itemType = ExtensionService.getAll()[item.type]?.name

                        return (
                            <ListItem role="presentation" key={keys.getKey(item)}>
                                <button
                                    role="menuitem"
                                    className="plugin-annotations__text-button"
                                    onClick={() => {
                                        actions.selectExportOption(item)
                                    }}
                                >
                                    <ItemName>{item.name}</ItemName>
                                    {itemType ? <ItemType>{itemType}</ItemType> : null}
                                </button>
                            </ListItem>
                        )
                    })}
                </List>
            ) : null}
            <SelectedItem event={event} onClose={actions.closeDropdown} item={selectedItem} {...rest} />
        </div>
    )
}

const ItemName = styled.span`
    display: block;
    color: #37a3ef;
    font-size: 12px !important;
`
const ItemType = styled.span`
    margin-top: 1px;
    display: block;
    font-size: 10px !important;
    color: #868695;
`
const List = styled.ul`
    margin: 0;
    padding: 0;
    border-radius: 0.1875em;
    border: 0.0625em solid #c8ccd4;
    box-shadow: 0px 2px 9px rgba(18, 23, 32, 0.2);
`
const ListItem = styled.li`
    padding: 4px 8px;
    font-family: ${theme['font-semibold']} !important;
    &:hover {
        background-color: #e1f0ff;
    }
    :first-child {
        padding-top: 8px;
    }

    :last-child {
        padding-bottom: 8px;
    }
`

export default ExportAnnotation
